import request from '@/service/request';

const countryMap: any = {
  vi: 'vn',
  id: 'id',
  ph: 'ph',
  th: 'th',
};

export const getArticleDetail = (params: any) => {
  const { country, id } = params;

  // 临时针对印尼改一下prefix
  if (country === 'id' && ENV === 'prod') {
    return request(`/v2/ignite/${countryMap[country]}/public/articles/${id}`, {
      prefix: 'https://api.id.iglooinsure.com',
    });
  }

  return request(`/v2/ignite/${countryMap[country]}/public/articles/${id}`);
};
